<template lang="pug">
auth-layout-view.login-mobile-id-page
  login-mobile-id-form(:error   = 'authError'
                       :loading = '$loading.isLoading("auth:mobileId")'
                       :code    = 'code'
                       @input   = 'clearError'
                       @submit  = 'mobileIdLogin')
</template>

<script>
import { mapState, mapActions } from "vuex";
import AuthLayoutView from "./AuthLayoutView";
import LoginMobileIdForm from "./LoginMobileIdForm";

export default {
  name: "login-mobile-id-page",

  components: {
    AuthLayoutView,
    LoginMobileIdForm
  },

  computed: {
    ...mapState("auth", ["authError", "isLoggedIn", "mobileIdData"]),
    code() {
      return this.mobileIdData?.challenge;
    }
  },

  watch: {
    isLoggedIn: {
      handler: function(val) {
        if (val) this.$router.push({ name: "Home", query: { lang: localStorage.getItem('locale') } });
      },
      immediate: true
    }
  },

  methods: mapActions("auth", ["clearError", "mobileIdLogin"])
};
</script>
